import React from 'react'
import { CircularProgress, Grid } from '@material-ui/core'

/**
 * Material-UI CircularProgress with centralized position
 * @param {*} param0
 */
const CircularLoading = ({ size }) => {
  return (
    <Grid container direction='row' justify='center' alignItems='center'>
      <CircularProgress size={size} style={{ marginTop: 136 }} />
    </Grid>
  )
}

export default CircularLoading
